import { Pipe, PipeTransform } from '@angular/core';
import { AcaoLogGeral } from '../../models/logGeral/AcaoLogGeral';

@Pipe({
  name: 'acaoLogGeral',
})
export class AcaoLogGeralPipe implements PipeTransform {
  transform(value: AcaoLogGeral): string {
    return {
      [AcaoLogGeral.Alteracao]: 'Alteração',
      [AcaoLogGeral.Exclusao]: 'Exclusão',
      [AcaoLogGeral.Inclusao]: 'Inclusão',
    }[value];
  }
}
